export default {
    NAME: 'ConfigReducer',
    DEFAULT_AREA: 'default',
    DEFAULT_VALUE: 'NOT-SET',
    ACTION_NAMES: {
        SET_CONFIG_VALUE: 'SET_CONFIG_VALUE'
    }
}
